import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { IamAccountDataAccessModule } from "@youm-front/iam-account/data-access";
import { UiModule } from "@youm-front/ui";
import { UiSvgModule } from "@youm-front/ui-svg";
import Components from "./components";
import Facades from "./facades";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    IamAccountDataAccessModule,
    UiModule,
    UiSvgModule
  ],
  declarations: [Components],
  providers: [Facades]
})
export class IAMAccountFeaturePasswordUpdateModule {}
